// extracted by mini-css-extract-plugin
export default {"actionBtn":"Payment_actionBtn__0NOa0","confirm":"Payment_confirm__KcqBF","reject":"Payment_reject__+aB9r"};